import React, { useMemo } from 'react'
import { Input } from 'antd'
import { Icon } from '@iconify/react'
import MemberHealthCard from './MemberHealthCard'
import styles from './ProjectHealthDashboard.module.css'

const MemberHealthList = ({ members, search, onSearchChange }) => {
    const filtered = useMemo(() => {
        const list = Array.isArray(members) ? members : []
        const q = String(search || '')
            .trim()
            .toLowerCase()
        if (!q) return list
        return list.filter((m) =>
            String(m?.name || '')
                .toLowerCase()
                .includes(q)
        )
    }, [members, search])

    const activeMembers = filtered.filter(
        (m) => (m?.taskCount ?? 0) > 0 || (m?.loggedHours ?? 0) > 0
    )
    const idleMembers = filtered.filter(
        (m) => !((m?.taskCount ?? 0) > 0 || (m?.loggedHours ?? 0) > 0)
    )

    return (
        <section className={styles.membersSection}>
            <div className={styles.membersSectionHeader}>
                <div>
                    <h3 className={styles.sectionTitle}>Team breakdown</h3>
                    <p className={styles.sectionSubtitle}>
                        Estimated vs logged hours per member and task
                    </p>
                </div>
                <Input
                    allowClear
                    placeholder="Search members"
                    prefix={
                        <Icon
                            icon="mdi:magnify"
                            width={18}
                            height={18}
                            style={{ color: '#94a3b8' }}
                        />
                    }
                    value={search}
                    onChange={(e) => onSearchChange?.(e.target.value)}
                    className={styles.memberSearch}
                />
            </div>

            {activeMembers.length > 0 && (
                <div className={styles.memberList}>
                    {activeMembers.map((member) => (
                        <MemberHealthCard
                            key={member.userId || member.name}
                            member={member}
                        />
                    ))}
                </div>
            )}

            {idleMembers.length > 0 && (
                <>
                    <p className={styles.idleMembersLabel}>
                        Members with no logged work ({idleMembers.length})
                    </p>
                    <div className={styles.memberList}>
                        {idleMembers.map((member) => (
                            <MemberHealthCard
                                key={member.userId || member.name}
                                member={member}
                            />
                        ))}
                    </div>
                </>
            )}

            {filtered.length === 0 && (
                <div className={styles.emptyMembers}>
                    No members match your search.
                </div>
            )}
        </section>
    )
}

export default MemberHealthList
